function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Facebook");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "All-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home---1820x1024",
  transform: "translate(-930.000000, -722.000000)"
}, React.createElement("g", {
  id: "popup",
  transform: "translate(664.000000, 557.000000)"
}, React.createElement("g", {
  id: 2,
  transform: "translate(250.000000, 141.000000)"
}, React.createElement("g", {
  id: "Icons/Facebook",
  transform: "translate(16.000000, 24.000000)"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#6243F4",
  cx: 10,
  cy: 10,
  r: 10
}), React.createElement("path", {
  d: "M12.3117147,5.00208067 L11.112442,5 C9.76510035,5 8.89438896,5.96594988 8.89438896,7.46101349 L8.89438896,8.5957055 L7.68857396,8.5957055 C7.58437722,8.5957055 7.5,8.6870468 7.5,8.79971495 L7.5,10.4437544 C7.5,10.5564225 7.58447344,10.6476598 7.68857396,10.6476598 L8.89438896,10.6476598 L8.89438896,14.7960946 C8.89438896,14.9087627 8.97876619,15 9.08296292,15 L10.6562085,15 C10.7604052,15 10.8447825,14.9086587 10.8447825,14.7960946 L10.8447825,10.6476598 L12.2546614,10.6476598 C12.3588582,10.6476598 12.4432354,10.5564225 12.4432354,10.4437544 L12.4438127,8.79971495 C12.4438127,8.74561759 12.4238969,8.69380897 12.3885874,8.65552469 C12.3532779,8.61724041 12.3051723,8.5957055 12.2551425,8.5957055 L10.8447825,8.5957055 L10.8447825,7.63381293 C10.8447825,7.17148861 10.9466701,6.93678932 11.5036368,6.93678932 L12.3115223,6.93647722 C12.4156228,6.93647722 12.5,6.84513592 12.5,6.73257181 L12.5,5.20598608 C12.5,5.093526 12.415719,5.00228873 12.3117147,5.00208067 Z",
  id: "Path",
  fill: "#FFFFFF"
}))))));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.1b8827d4.svg";
export { ForwardRef as ReactComponent };